// extracted by mini-css-extract-plugin
export default {"container":"component_form_preview_container__dSwrj","description":"component_form_preview_description__0iqRf"};